import { useEffect, useRef, useState } from "react";
import { TextField } from "@mui/material";
import { observer } from "mobx-react-lite";
import { ISearchFilterConfig } from "../../constants/interfaces";

const SearchFilter = observer(
  ({
    label,
    placeholder,
    sx = { width: 200 },
    onAction,
    onChange,
    id,
    initialValue = "",
    minChars = 3,
    debounceMs = 1500,
  }: ISearchFilterConfig) => {
    const [inputValue, setInputValue] = useState<string>(initialValue);
    const isFirstRender = useRef(true);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = event.target.value;

      setInputValue(newValue);

      if (onChange) {
        onChange(newValue);
      }
    };

    useEffect(() => {
      setInputValue(initialValue);
    }, [initialValue]);

    useEffect(() => {
      if (isFirstRender.current) {
        isFirstRender.current = false;
        return;
      }

      const trimmedValue = inputValue.trim();

      if (trimmedValue.length > 0 && trimmedValue.length < minChars) {
        return;
      }

      const timeout = setTimeout(() => {
        onAction(trimmedValue);
      }, debounceMs);

      return () => clearTimeout(timeout);
    }, [inputValue, onAction, minChars, debounceMs]);

    return (
      <TextField
        id={id}
        size="small"
        label={label}
        placeholder={placeholder}
        value={inputValue}
        onChange={handleChange}
        sx={{
          ...sx,
          "& .MuiOutlinedInput-input": {
            fontSize: "1.5rem",
          },
        }}
      />
    );
  }
);

export default SearchFilter;
